export default __webpack_public_path__ + "static/media/plumbeous.7539237d.jpg";